import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=25369151&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=25369151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25369151",
  null
  
)

export default component.exports